export const getLoginQRCodeFromSessionId = sessionId => `l${sessionId}`
